const TIME_RE_COMPUTED = 1000 * 60; // 1minute

// 単品メニュー表示（Menus.a_la_carte_display）
const A_LA_CARTE_OPTION_ONLY_STAFF = 2; // ホールスタッフのみ表示

export {
    TIME_RE_COMPUTED,
    A_LA_CARTE_OPTION_ONLY_STAFF
}